import { render, staticRenderFns } from "./VendorDetails.vue?vue&type=template&id=ba37e3b2&scoped=true&"
import script from "./VendorDetails.vue?vue&type=script&lang=js&"
export * from "./VendorDetails.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=ba37e3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba37e3b2",
  null
  
)

export default component.exports